import request from '@/utils/request'

export function listCouponPropertyUser(params) {
    return request({
      url: '/couponProperty.listCouponPropertyUser',
      method: 'get',
      params
    }).then(response => response.data)
  }

export function listComplaints(params) {
    return request({
      url: '/complaint/listComplaints',
      method: 'get',
      params
    })
  }
